
export default {
    methods: {
        asAsyncComponent(component) {
            return {
                // The component to load (should be a Promise)
                component: component,
                // A component to use while the async component is loading
                loading: DefaultSpinner,
                // A component to use if the load fails
                error: null,
                // Delay before showing the loading component. Default: 200ms.
                delay: 10
            }
        }
    }
}
